import React from 'react'
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '~/lib/ui/table'
import Pagination from './Pagination'
import { useCandidateActivity } from './CandidateActivitySection'
import { useQuery } from '@tanstack/react-query'
import { apiGet } from '~/util/api'

const PAGE_SIZE = 50

const JobAlerts = () => {
  const { candidateJobAlerts } = useCandidateActivity()
  const [page, setPage] = React.useState(1)
  const total = candidateJobAlerts?.length || 0

  // Paginate activities
  const paginated = React.useMemo(() => {
    if (!candidateJobAlerts) return []
    const start = (page - 1) * PAGE_SIZE
    return candidateJobAlerts.slice(start, start + PAGE_SIZE)
  }, [candidateJobAlerts, page])

  return (
    <>
      <Table
        className="w-full border-separate"
        tableClass="w-full rounded-2xl border border-silver"
      >
        <JobAlertsHeading />
        <TableBody>
          {paginated.map((candidateJobAlert) => (
            <JobAlertsRow
              key={`candidate-job-alerts-${candidateJobAlert.id}`}
              candidateJobAlert={candidateJobAlert}
            />
          ))}
        </TableBody>
      </Table>
      {total > PAGE_SIZE && (
        <Pagination
          page={page}
          pageSize={PAGE_SIZE}
          total={total}
          onPageChange={setPage}
        />
      )}
    </>
  )
}

export default JobAlerts

const JobAlertsRow = ({ candidateJobAlert, ...props }) => {
  const {
    id,
    name,
    frequency,
    method,
    url,
    survey_result: surveyResult,
  } = candidateJobAlert || {}

  const queryFn = () =>
    apiGet(`/coach/metrics/alerts/${id}/job_count_from_id`).then(
      (res) => res.data,
    )

  const { isError, isLoading, data } = useQuery({
    queryKey: ['resultCount', id],
    queryFn,
  })

  const resultCount = data?.job_count || '—'

  return (
    <TableRow
      {...props}
      className="odd:bg-white even:bg-[#e2e2e2] even:bg-opacity-[29%]"
    >
      <TableCell>{name}</TableCell>
      <TableCell>{frequency}</TableCell>
      <TableCell>{method}</TableCell>
      <TableCell>
        {isLoading ? (
          <span className="animate-pulse text-gray-400">Loading...</span>
        ) : isError ? (
          'Error loading job alert count'
        ) : (
          resultCount
        )}
      </TableCell>
      <TableCell>
        <a href={url} target="_blank" rel="noopener noreferrer">
          View
        </a>
      </TableCell>
      <TableCell>{surveyResult}</TableCell>
    </TableRow>
  )
}

const JobAlertsHeading = () => {
  const cells = [
    'Criteria',
    'Frequency',
    'Method',
    'Result Count',
    'View',
    'Survey Result',
  ]
  return (
    <TableHeader className="h-6 bg-intoo-blue-medium">
      <TableRow className="text-lg text-white hover:bg-intoo-blue-medium">
        {cells.map((cell, index) => (
          <TableHead key={index} className="font-medium text-white">
            {cell}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  )
}
